import { Button } from '@cian/ui-kit/button';
import classNames from 'classnames';
import * as React from 'react';

import { IRosbankBannerComponentProps } from '../../../types/rosbankBanners';
import * as styles from './styles.css';

export const RosbankPilotBannerSaleNew: React.FC<IRosbankBannerComponentProps> = ({ url, onClick }) => {
  return (
    <div className={styles['container']} data-testid="rosbank-pilot-banner-salenew">
      <a
        className={classNames(styles['wrapper'], styles['flatnew'])}
        href={url}
        rel="noreferrer"
        onClick={onClick}
        data-testid="rosbank-pilot-banner-inner-wrapper"
      >
        <div className={styles['title']}>Купите новостройку уже сейчас</div>
        <div className={styles['subtitle']}>И живите в своей квартире до готовности новой</div>
        <div>
          <Button size="M" theme="fill_primary">
            Узнать как
          </Button>
        </div>
      </a>
    </div>
  );
};
